<template>
  <button
    type="button"
    class="toggle-switch"
    :class="{ 'toggle-switch--on': props.active }"
    :aria-pressed="props.active"
    :aria-label="props.label"
    @click="emit('toggle')"
  >
    <span class="toggle-switch__thumb" />
  </button>
</template>

<script setup lang="ts">
interface Props {
  active: boolean
  label?: string
}
interface Emits {
  (e: 'toggle'): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()
</script>

<style scoped lang="scss">
.toggle-switch {
  position: relative;
  width: 42px;
  height: 24px;
  padding: 0;
  border: 0;
  border-radius: 999px;
  background: #c5c9ce;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s ease;

  &--on {
    background: var(--primary-blue, #0042b8);
  }
}

.toggle-switch__thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.2);
  transition: transform 0.15s ease;
}

.toggle-switch--on .toggle-switch__thumb {
  transform: translateX(18px);
}
</style>
